export default __webpack_public_path__ + "static/media/gallery-wip-pommel_02.e7d97600.jpg";